module.exports = __webpack_public_path__ + "img/confetti.c571d6cf.png";